
import Vue from "vue";
import { Plan } from "@/utils/payments/plan";
import { PriceFrequencyType, Pricing } from "../../models/payment/pricing";
import { PaymentService } from "../../services/payment-service";
import { printHumanFloat } from "../../utils/pretty-print";
import { Mandat } from "../../models/payment/mandat";
import AppAwaitingPayment from "@/components/account/AwaitingPaymentModal.vue";
import { ComputedPricing } from "@/models/payment/computed-pricing";
import AppOneOffPrice from "./ActivationCardOneOffPrice.vue";
import AppRecuringPrice from "./ActivationCardRecuringPrice.vue";
import AppPayRow from "./ActivationCardPayRow.vue";
import {AuthService} from "@/services";

export default Vue.extend({
	data() {
		return {
			awaitingPayment: false,
			discountCodeInput: "",
			pricing: null as Pricing | null,
			AuthService
		};
	},
	props: {
		plan: {
			type: Object as () => Plan,
			required: true
		},
		price: {
			type: Object as () => ComputedPricing,
			required: true
		},
		mandate: {
			type: Object as () => Mandat
		},
		discountCodeAllowed: Boolean,
		discountCode: String,
		renew: Boolean
	},
	computed: {
		isYearInterval(): boolean {
			return this.plan.paymentFrequency == PriceFrequencyType.YEAR;
		},
		buttonText(): string {
			let data = {amount: printHumanFloat(this.price.oneTimePrice.total)};
			if (this.renew) {
				return this.$ct("create-subscription").toString();
			}
			if (this.plan.paymentFrequency == PriceFrequencyType.PERMANENT) {
				return this.$ct(`activate-permanent`, data).toString();
			}
			if (this.isYearInterval) {
				return this.$ct("activate-year", data).toString();
			}
			return this.$ct("activate-quarter", data).toString();
		},
		nextPayment(): string {

			let data = {
				amount: printHumanFloat(this.price.oneTimePrice.discount),
				frequency: "",
				nextDiscount: "0.00",
				lifeTimeDiscount: "0.00"
			};

			let yearDiscount = 0;
			let permanentPrice = 0;
			let permanentDiscount = 0;

			if (this.pricing) {
				let p = this.plan.paymentFrequency == 0 ? this.price.oneTimePrice.discountPercent : this.price.oneTimePrice.discountPercent - 15;
				//remove adittional discount from year subscription
				yearDiscount = (this.price.oneTimePrice.price*4) * ((p)/100);
				permanentPrice = this.pricing.getPermanentPrice().getPriceOfTier(this.plan.tier);
				permanentDiscount = permanentPrice * (p / 100);
			}

			if (this.plan.paymentFrequency == 0) {
				data.frequency = this.$ct("next-payment-quarter").toString();
				data.lifeTimeDiscount = printHumanFloat(permanentDiscount);
				data.nextDiscount = printHumanFloat(yearDiscount);
				return this.$ct("discount-attention-quarter", data).toString();
			} else if (this.plan.paymentFrequency == 1) {
				data.frequency = this.$ct("next-payment-year").toString();
				yearDiscount = yearDiscount / 4;
				data.amount = printHumanFloat(yearDiscount);
				data.lifeTimeDiscount = printHumanFloat(permanentDiscount);
				return this.$ct("discount-attention-year", data).toString();
			}

			return this.$ct("discount-attention", data).toString();
		},
		showOneTimePrice(): boolean {
			if (this.renew) {
				return false;
			}
			if (this.plan.paymentFrequency == PriceFrequencyType.PERMANENT) {
				return true;
			}
			if (this.price.oneTimePrice.total != this.price.recuringPrice.total) {
				return true;
			}
			return false;
		},
		showRecuringPrice(): boolean {
			if (this.renew) {
				return true;
			}
			if (this.plan.paymentFrequency == PriceFrequencyType.PERMANENT) {
				return false;
			}
			return true;
		}
	},
	methods: {
		async createSubscription() {
			if (this.renew){
				await PaymentService.extendPlan();
				this.$router.push("/");
				return;
			}
			if (this.plan.paymentFrequency == PriceFrequencyType.PERMANENT) {
				await PaymentService.buyLifetimePlan(this.plan, this.discountCode);
				return;
			}
			let mandateId = "";
			if (this.mandate) {
				mandateId = this.mandate.id;
			}
			let shouldReload = await PaymentService.createSubscription(this.plan, mandateId, this.discountCode);
			if (shouldReload) {
				this.awaitingPayment = true;
			}
		},
		toggleInterval() {
			if (this.plan.paymentFrequency == PriceFrequencyType.QUARTER) {
				this.plan.paymentFrequency = PriceFrequencyType.YEAR;
			} else if (this.plan.paymentFrequency == PriceFrequencyType.YEAR) {
				this.plan.paymentFrequency = PriceFrequencyType.QUARTER;
			} else if (this.plan.paymentFrequency == PriceFrequencyType.PERMANENT) {
				this.plan.paymentFrequency = PriceFrequencyType.PERMANENT;
			}
		},
		toggleYear() {
			this.plan.paymentFrequency = PriceFrequencyType.YEAR;
		},
		togglePermanent() {
			this.plan.paymentFrequency = PriceFrequencyType.PERMANENT;
		},
		checkDiscountCode() {
			this.$emit("new-discount-code", this.discountCodeInput);
		}
	},
	async mounted() {
		this.pricing = await PaymentService.getPricing();
	},
	components: {
		AppAwaitingPayment,
		AppOneOffPrice,
		AppRecuringPrice,
		AppPayRow
	},
	i18nEx: {
		componentPrefix: "components.account"
	}
});
